import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Download, Eye, CheckCircle } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    icon: <Download className="w-8 h-8 text-accent" data-id="element-171" />,
    title: 'Descarga y Aprende',
    desc: 'Descargas el manual y aprendes la Tríada de la Verdad en 15 minutos.'
  }, {
    number: '02',
    icon: <Eye className="w-8 h-8 text-accent" data-id="element-172" />,
    title: 'Observación Silenciosa',
    desc: 'Aplicas la observación silenciosa en tu próxima conversación (sin decir nada).'
  }, {
    number: '03',
    icon: <CheckCircle className="w-8 h-8 text-accent" data-id="element-173" />,
    title: 'Confirma Sospechas',
    desc: 'Confirmas tus sospechas al ver cómo la realidad coincide con las señales corporales que aprendiste.'
  }];
  return <section className="py-24 bg-surface relative overflow-hidden" data-id="element-174">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-175"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-176">
        <div className="text-center mb-20" data-id="element-177">
          <FadeIn data-id="element-178">
            <h2 className="text-4xl sm:text-5xl font-black text-white mb-6" data-id="element-179">
              Cómo funciona:
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-180">
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-181">
              Un proceso simple, discreto y altamente efectivo.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-182">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-accent/30 to-transparent -translate-y-1/2 z-0" data-id="element-183"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="up" data-id="element-184">
              <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-185">
                <div className="w-24 h-24 rounded-full bg-background border-2 border-accent/20 flex items-center justify-center mb-8 relative shadow-[0_0_30px_rgba(212,168,83,0.1)] group-hover:border-accent group-hover:shadow-[0_0_40px_rgba(212,168,83,0.3)] transition-all duration-500" data-id="element-186">
                  <div className="absolute -top-4 -right-4 w-10 h-10 rounded-full bg-accent text-background font-bold flex items-center justify-center text-lg shadow-lg" data-id="element-187">
                    {step.number}
                  </div>
                  {step.icon}
                </div>

                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-188">
                  {step.title}
                </h3>
                <p className="text-lg text-slate-400 leading-relaxed max-w-xs mx-auto" data-id="element-189">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* Transformation Statement */}
        <div className="mt-24 max-w-4xl mx-auto" data-id="element-190">
          <FadeIn delay={0.5} data-id="element-191">
            <div className="bg-gradient-to-br from-accent/10 to-transparent border border-accent/20 rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-192">
              <div className="absolute inset-0 bg-neural-pattern opacity-30 mix-blend-overlay" data-id="element-193"></div>
              <p className="text-2xl sm:text-3xl font-bold text-white leading-relaxed relative z-10" data-id="element-194">
                <span className="text-accent" data-id="element-195">
                  Lo único que cambia en 7 días
                </span>{' '}
                es que dejarás de "oír" a la gente y empezarás a "leerla". Tu
                percepción del mundo social se volverá de alta definición.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}